/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
import { useEffect, useState } from "react";
import { numberToCurrency } from "utils/MathFunction";
import GKCharts from "./GKCharts";
import GKTypography from "./GKTypography";
import { Show } from "./Show";

const DoughnutChart = ({ data, loading }: any) => {
  const [hoverData, setHoverData] = useState<any>();

  const chartOptions = {
    title: {
      text: " ",
      align: "center",
      verticalAlign: "middle",
      style: {
        fontSize: "1.1em",
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    chart: {
      width: 335,
      height: 220,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      text: "",
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
        animation: false,
      },
      pie: {
        dataLabels: {
          enabled: false,
        },
        point: {
          events: {
            mouseOut: function () {
              setHoverData({
                name: "Portfolio Value",
                y: data?.data?.portfolioValue,
              });
            },
            mouseOver: function (this) {
              setHoverData(this);
            },
          },
        },
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "100%"],
        size: "190%",
        borderRadius: 6,
      },
    },
    colors: ["var(--primary-900)", "var(--secondary-900)"],
    series: [
      {
        type: "pie",
        name: " ",
        innerSize: "75%",
        data: [
          ["All Holdings", data?.data?.currentValue],
          ["Ledger Balance", data?.data?.cash],
        ],
      },
    ],
  };

  useEffect(() => {
    setHoverData({
      name: "Portfolio Value",
      y: data?.data?.portfolioValue,
    });
  }, [data]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        position: "relative",
        alignItems: "center",
      }}
    >
      <Show.When isTrue={hoverData}>
        <div
          style={{
            position: "absolute",
            bottom: 40,
            zIndex: 1,
          }}
        >
          <GKTypography
            color={"var(--neutral-500)"}
            fontSize={14}
            textAlign={"center"}
          >
            {hoverData?.name}
          </GKTypography>
          <GKTypography
            fontWeight={600}
            fontSize={18}
            textAlign={"center"}
            loading={loading}
          >
            {numberToCurrency(hoverData?.y || 0)}
          </GKTypography>
        </div>
      </Show.When>
      <GKCharts chartOptions={chartOptions} loading={loading} />
    </div>
  );
};

export default DoughnutChart;
